a.ctaButton,
button.ctaButton {
  font-family: 'Onest', sans-serif;
  font-weight: 350;
  text-transform: none;
  color: #fffdf7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  corner-shape: superellipse(1.18);
  border-radius: 100px;
  cursor: pointer;
  border: none;
  & span > img:first-child {
    filter: invert(1) brightness(1000%);
  }
}

a.ctaButton.outlined:hover {
  & img {
    filter: invert(1) brightness(1000%) !important;
  }
}
a.outlined,
button.outlined {
  & img {
    filter: brightness(0) saturate(100%) invert(65%) sepia(40%) saturate(776%)
      hue-rotate(354deg) brightness(90%) contrast(93%) !important;
  }
}

/* Small */
a.ctaButton.smallSize,
button.ctaButton.smallSize {
  height: 36px;
  padding: 0 1rem;
  border-radius: 100px;
}
a.ctaButton.smallSize p,
button.ctaButton.smallSize p {
  font-size: 0.75rem;
}

/* Medium */
a.ctaButton.mediumSize,
button.ctaButton.mediumSize {
  height: 46px;
  padding: 0 1.5rem;
  border-radius: 100px;
}
a.ctaButton.mediumSize p,
button.ctaButton.mediumSize p {
  font-size: 0.9rem;
}

/* Large */
a.ctaButton.largeSize,
button.ctaButton.largeSize {
  height: 54px;
  padding: 0 2rem;
  border-radius: 100px;
}
a.ctaButton.largeSize p,
button.ctaButton.largeSize p {
  font-size: 1rem;
}

.ctaButton .MuiIcon-root {
  margin: 0;
}

/*Primary Variant*/
a.ctaButton.primaryVariant,
button.ctaButton.primaryVariant {
  background-color: #505050;
}
a.ctaButton.primaryVariant:hover,
button.ctaButton.primaryVariant:hover {
  background-color: #727272;
  color: #fffdf7;
}

a.ctaButton.primaryVariant.outlined,
button.ctaButton.primaryVariant.outlined {
  background-color: transparent;
  color: #505050;
  border: 2px solid #505050;
}
a.ctaButton.primaryVariant.outlined:hover,
button.ctaButton.primaryVariant.outlined:hover {
  background-color: #505050;
  color: #fffdf7;
}

/*Danger Variant*/
a.ctaButton.dangerVariant,
button.ctaButton.dangerVariant {
  background-color: #fffdf7;
  color: #505050;
}
a.ctaButton.dangerVariant:hover,
button.ctaButton.dangerVariant:hover {
  background-color: #fffdf7;
}

a.ctaButton.dangerVariant.outlined,
button.ctaButton.dangerVariant.outlined {
  background-color: transparent;
  color: #fffdf7;
  border: 2px solid #fffdf7;
}
a.ctaButton.dangerVariant.outlined:hover,
button.ctaButton.dangerVariant.outlined:hover {
  background-color: #fffdf7;
  color: #505050;
  border: 2px solid #fffdf7;
}

/*Grey Variant*/
a.ctaButton.greyVariant,
button.ctaButton.greyVariant {
  background-color: #979797;
}
a.ctaButton.greyVariant:hover,
button.ctaButton.greyVariant:hover {
  background-color: #8b8b8b;
  color: #fffdf7;
}

a.ctaButton.greyVariant.outlined,
button.ctaButton.greyVariant.outlined {
  background-color: transparent;
  color: #979797;
  border: 2px solid #979797;
}
a.ctaButton.greyVariant.outlined:hover,
button.ctaButton.greyVariant.outlined:hover {
  background-color: #8b8b8b;
}
a.ctaButton.greyVariant.outlined:hover {
  background-color: #8b8b8b;
  color: #fffdf7;
}

/* icon boost */
.ctaButton.smallSize .MuiSvgIcon-root {
  font-size: 1.25rem;
}
.ctaButton.mediumSize .MuiSvgIcon-root {
  font-size: 1.5rem;
}
.ctaButton.largeSize .MuiSvgIcon-root {
  font-size: 2rem;
}
